<template>
  <!-- 团队发票 -->
  <div>
    <el-card shadow="never" class="real_card" v-if="!invoiceDetailVisible && !uploadCertificateVisible && !mallInvoiceDetailVisible">
      <div slot="header" class="clearfix">
        <div class="desciconLarge"></div>
        <span class="font18">团队发票</span>
      </div>

      <el-tabs v-model="activeInvoiceTab" type="card" @tab-click="changeInvoiceTab">
        <el-tab-pane label="检测发票" name="detect">
          <div class="filter-box">
            <el-select v-model="status_index" clearable @change="changeInvoiceStatus" @clear="clearQuerySearch" placeholder="开票状态">
              <el-option
                v-for="item in dicts.myInvoiceStatus"
                :key="item.index"
                :label="item.dictLabel"
                :value="item.index">
              </el-option>
            </el-select>
            <el-button @click="downloadFile()" style="float: right;">下载测试报告模板</el-button>
          </div>
          <span class="formTips">请在收到发票两周内完成报销，报销交给财务时，切记提醒财务转账时备注“发票号后8位或下单人姓名”</span>
          <el-table :data="tableData" border style="width: 100%;min-height: 500px"
            :header-cell-style="{ background: '#F5F5F5',fontSize: '13px' }">
            <el-table-column prop="applyCode" label="申请编号"></el-table-column>
            <el-table-column prop="invoiceTitle" label="发票抬头"></el-table-column>
            <el-table-column prop="invoiceType" label="发票类型">
              <template slot-scope="scope">
                {{ dictFilter(scope.row.invoiceType ? scope.row.invoiceType.toString() : '-', 'invoiceType') }}
              </template>
            </el-table-column>
            <el-table-column prop="addDate" label="申请时间"></el-table-column>
            <el-table-column prop="invoiceAmount" label="开票金额(元)">
              <template slot-scope="scope">¥{{ scope.row.invoiceAmount || '0.00' }}</template>
            </el-table-column>
            <el-table-column prop="invoiceStatus" label="开票状态">
              <template slot-scope="scope">{{ statusFilter(scope.row) }}</template>
            </el-table-column>
            <el-table-column prop="paymentStatus" label="是否回款">
              <template slot-scope="scope">
                {{ dictFilter(scope.row.paymentStatus ? scope.row.paymentStatus.toString() : '-', 'paymentStatus') }}
              </template>
            </el-table-column>
            <el-table-column prop="accountingInformation" label="需报账资料">
              <template slot-scope="scope">
                <div class="clickName" v-if="scope.row.accountingListInfoList && scope.row.accountingListInfoList.length" @click="fileHandle(scope.row.accountingListInfoList, '电子版测试清单')">电子版测试清单</div>
                <div class="clickName" v-if="scope.row.accountingContractInfoList && scope.row.accountingContractInfoList.length" @click="fileHandle(scope.row.accountingContractInfoList, '电子合同')">电子合同</div>
                <div class="clickName" v-if="scope.row.accountingReportInfoList && scope.row.accountingReportInfoList.length" @click="fileHandle(scope.row.accountingReportInfoList, '电子报告')">电子报告</div>
                <div class="clickName" v-if="scope.row.standingbookInfoList && scope.row.standingbookInfoList.length" @click="fileHandle(scope.row.standingbookInfoList, '对账单')">对账单</div>
                <div class="clickName" v-if="scope.row.accountingOtherInfoList && scope.row.accountingOtherInfoList.length" @click="fileHandle(scope.row.accountingOtherInfoList, '其他资料')">其他资料</div>
              </template>
            </el-table-column>
            <el-table-column prop="certificateStatus" label="凭证状态">
              <template slot-scope="scope">{{ scope.row.certificateStatus == 2 ? '已上传' : '未上传' }}</template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div class="clickName" @click="downInvoice(scope.row)" v-if="scope.row.invoiceStatus == 3">下载发票</div>
                <div class="clickName" @click="delHandle(scope.row)" v-if="scope.row.invoiceStatus == 5">删除</div>
                <div class="clickName" @click="uploadCertificateHandle(scope.row)"
                  v-if="scope.row.certificateStatus == 1 && (scope.row.invoiceStatus == 2 || scope.row.invoiceStatus == 3)">上传打款凭证</div>
                <div class="clickName" @click="detailInfo(scope.row)">查看详情</div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background v-if="total > 0" style="text-align: right;margin-top: 10px"
            layout="total,prev, pager, next,sizes,jumper" :current-page="querySearch.pageNum"
            :page-size="querySearch.pageSize" :total="total" @current-change="selPageChange"
            @size-change="handleSizeChange"></el-pagination>
        </el-tab-pane>

        <el-tab-pane label="耗材发票" name="mall">
          <div class="mall-filter-box">
            <span class="mall-filter-label">开票状态：</span>
            <el-select v-model="mallQuerySearch.invoiceStatus" clearable placeholder="全部状态" @change="changeMallInvoiceStatus" @clear="clearMallInvoiceStatus">
              <el-option v-for="item in mallInvoiceStatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <el-table :data="mallTableData" border style="width: 100%;min-height: 500px" :header-cell-style="{ background: '#F5F5F5',fontSize: '13px' }">
            <el-table-column prop="applyCode" label="发票申请号" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="applyTypeText" label="申请类型" min-width="100"></el-table-column>
            <el-table-column prop="invoiceTitle" label="发票抬头" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="invoiceTypeText" label="发票类型" min-width="90"></el-table-column>
            <el-table-column prop="invoiceAmount" label="申请金额(元)" min-width="120"><template slot-scope="scope">¥{{ scope.row.invoiceAmount }}</template></el-table-column>
            <el-table-column prop="auditStatusText" label="审核状态" min-width="100"><template slot-scope="scope"><span class="status-tag" :class="scope.row.auditStatusClass">{{ scope.row.auditStatusText }}</span></template></el-table-column>
            <el-table-column prop="invoiceStatusText" label="开票状态" min-width="100"><template slot-scope="scope"><span class="status-tag" :class="scope.row.invoiceStatusClass">{{ scope.row.invoiceStatusText }}</span></template></el-table-column>
            <el-table-column prop="addDate" label="申请时间" min-width="150"></el-table-column>
            <el-table-column label="操作" align="center" min-width="120" fixed="right"><template slot-scope="scope"><el-button type="text" @click="mallDetailInfo(scope.row)">查看详情</el-button></template></el-table-column>
          </el-table>
          <el-pagination background v-if="mallTotal > 0" style="text-align: right;margin-top: 10px" layout="total,prev, pager, next,sizes,jumper" :current-page="mallQuerySearch.pageNum" :page-size="mallQuerySearch.pageSize" :total="mallTotal" @current-change="selMallPageChange" @size-change="handleMallSizeChange"></el-pagination>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- 检测发票详情 -->
    <invoiceDetail v-if="invoiceDetailVisible" ref="invoiceDetail" @back="getList"></invoiceDetail>
    <!-- 打款凭证 -->
    <uploadCertificate v-if="uploadCertificateVisible" ref="uploadCertificate" @back="getList"></uploadCertificate>
    <!-- 团队耗材发票详情 -->
    <el-card shadow="never" class="create_card mall-invoice-detail" v-if="mallInvoiceDetailVisible">
      <div slot="header" class="clearfix"><el-button type="text" class="backBtn" @click="backMallInvoiceDetail">返回</el-button><span class="font18">发票详情</span></div>
      <div class="detail-section"><div class="descicon"></div><span class="font16">申请信息</span>
        <div class="detail-grid">
          <div class="detail-grid-item"><span>申请编号:</span>{{ mallInvoiceDetailInfo.applyCode || '-' }}</div><div class="detail-grid-item"><span>申请类型:</span>{{ mallInvoiceDetailInfo.applyTypeText || '-' }}</div>
          <div class="detail-grid-item"><span>发票类型:</span>{{ mallInvoiceDetailInfo.invoiceTypeText || '-' }}</div><div class="detail-grid-item"><span>申请金额(元):</span>¥{{ mallInvoiceDetailInfo.invoiceAmount || '0.00' }}</div>
          <div class="detail-grid-item"><span>审核状态:</span>{{ mallInvoiceDetailInfo.auditStatusText || '-' }}</div><div class="detail-grid-item"><span>开票状态:</span>{{ mallInvoiceDetailInfo.invoiceStatusText || '-' }}</div>
          <div class="detail-grid-item"><span>申请时间:</span>{{ mallInvoiceDetailInfo.addDate || '-' }}</div><div class="detail-grid-item"><span>需开票日期:</span>{{ mallInvoiceDetailInfo.clientNeedInvoiceDate || '-' }}</div>
          <div class="detail-grid-item full-line"><span>备注:</span>{{ mallInvoiceDetailInfo.remark || '-' }}</div>
        </div>
      </div>
      <div class="detail-section"><div class="descicon"></div><span class="font16">发票抬头及收件信息</span><div class="detail-grid">
        <div class="detail-grid-item"><span>发票抬头:</span>{{ mallInvoiceDetailInfo.invoiceTitle || '-' }}</div><div class="detail-grid-item"><span>企业税号:</span>{{ mallInvoiceDetailInfo.enterpriseTaxNumber || '-' }}</div>
        <div class="detail-grid-item"><span>收件联系人:</span>{{ mallInvoiceDetailInfo.receivingContact || '-' }}</div><div class="detail-grid-item"><span>联系方式:</span>{{ mallInvoiceDetailInfo.receivingContactInformation || '-' }}</div>
      </div></div>
      <div class="detail-section" v-if="mallInvoiceDetailInfo.items && mallInvoiceDetailInfo.items.length"><div class="descicon"></div><span class="font16">商品开票明细</span>
        <el-table :data="mallInvoiceDetailInfo.items" border size="mini"><el-table-column prop="goodsName" label="商品"></el-table-column><el-table-column prop="skuNo" label="SKU"></el-table-column><el-table-column prop="packageSpec" label="规格"></el-table-column><el-table-column prop="unit" label="单位"></el-table-column><el-table-column prop="quantity" label="数量"></el-table-column><el-table-column prop="unitPrice" label="单价"></el-table-column><el-table-column prop="invoiceAmount" label="开票金额"></el-table-column></el-table>
      </div>
      <div class="detail-section" v-if="mallInvoiceDetailInfo.results && mallInvoiceDetailInfo.results.length"><div class="descicon"></div><span class="font16">开票结果</span>
        <el-table :data="mallInvoiceDetailInfo.results" border size="mini">
          <el-table-column prop="invoiceMoney" label="开票金额"></el-table-column>
          <el-table-column prop="invoiceDate" label="开票日期"></el-table-column>
          <el-table-column prop="invoiceCode" label="发票号码"></el-table-column>
          <el-table-column prop="paymentStatus" label="回款状态">
            <template slot-scope="scope">{{ paymentStatusText(scope.row.paymentStatus) }}</template>
          </el-table-column>
          <el-table-column prop="invoiceFileUrl" label="附件">
            <template slot-scope="scope">
              <el-button type="text" v-if="scope.row.invoiceFileUrl" @click="downloadMallInvoice(scope.row)">下载</el-button>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="detail-section" v-if="mallInvoiceDetailInfo.applyLogs && mallInvoiceDetailInfo.applyLogs.length"><div class="descicon"></div><span class="font16">操作日志</span>
        <el-timeline class="invoice-log-timeline"><el-timeline-item v-for="(log, index) in mallInvoiceDetailInfo.applyLogs" :key="index" :timestamp="log.addTime" placement="top">{{ log.msg || log.context || '-' }}</el-timeline-item></el-timeline>
      </div>
    </el-card>
  </div>
</template>

<script>
import { invoiceList, invoiceDel, getInvoiceFile, teamMallInvoiceList, teamMallInvoiceInfo } from "@/api/request";
import { getClient, getReagentTeamInfo } from "@/plugins/auth";
import invoiceDetail from "./formPop/invoiceDetail"
import uploadCertificate from "./formPop/uploadCertificate"

export default {
  components: {
    invoiceDetail,
    uploadCertificate
  },
  data() {
    return {
      activeInvoiceTab: 'detect',
      tableData: [],
      invoiceDetailVisible: false,
      uploadCertificateVisible: false,
      mallInvoiceDetailVisible: false,
      mallInvoiceDetailInfo: {},
      total: 0,
      status_index: 0,
      querySearch: {
        pageNum: 1,
        pageSize: 10,
        orderByColumn: 'addDate',
        isAsc: 'desc',
        originTeamId: '',
      },
      mallTableData: [],
      mallTotal: 0,
      mallInvoiceStatusList: [
        { label: '全部状态', value: '' },
        { label: '待开票', value: '1' },
        { label: '已开票', value: '2' },
        { label: '开票失败', value: '4' },
      ],
      mallQuerySearch: this.getDefaultMallQuerySearch(),
    };
  },
  created() {
    const clientInfo = JSON.parse(getClient() || '{}')
    this.querySearch.originTeamId = clientInfo.teamId || ''
  },
  mounted() {
    this.getList();
  },
  methods: {
    changeInvoiceTab(tab) {
      const tabName = tab && tab.name ? tab.name : this.activeInvoiceTab
      this.activeInvoiceTab = tabName
      if(tabName == 'detect') {
        this.getList()
      } else {
        this.getMallInvoiceList()
      }
    },
    getList() {
      this.invoiceDetailVisible = false
      this.uploadCertificateVisible = false
      this.mallInvoiceDetailVisible = false
      const params = JSON.parse(JSON.stringify(this.querySearch))
      params[this.dicts.myInvoiceStatus[this.status_index].key] = this.dicts.myInvoiceStatus[this.status_index].dictValue
      invoiceList(params).then(res => {
        this.tableData = res.rows;
        this.total = res.total
      });
    },
    async getMallInvoiceList() {
      this.invoiceDetailVisible = false
      this.uploadCertificateVisible = false
      this.mallInvoiceDetailVisible = false
      const rmTeamId = this.getRmTeamId()
      if(!rmTeamId) {
        this.mallTableData = []
        this.mallTotal = 0
        return
      }
      try {
        // 团队耗材发票必须使用商城团队 ID，不能使用原业务团队 ID。
        const res = await teamMallInvoiceList(rmTeamId, this.buildMallInvoiceParams())
        const rows = this.extractMallInvoiceRows(res)
        this.mallTableData = rows.map(item => this.normalizeMallInvoice(item))
        this.mallTotal = this.extractMallInvoiceTotal(res, rows.length)
      } catch (error) {
        this.mallTableData = []
        this.mallTotal = 0
      }
    },
    getRmTeamId() {
      const reagentTeamInfo = JSON.parse(getReagentTeamInfo() || '{}')
      return reagentTeamInfo.rmTeamId || ''
    },
    getDefaultMallQuerySearch() {
      return { pageNum: 1, pageSize: 10, invoiceStatus: '' }
    },
    buildMallInvoiceParams() {
      const params = {}
      Object.keys(this.mallQuerySearch).forEach(key => {
        const value = this.mallQuerySearch[key]
        if(value !== '' && value !== null && value !== undefined) params[key] = value
      })
      return params
    },
    extractMallInvoiceRows(res) {
      const data = res && res.data
      if(Array.isArray(res && res.rows)) return res.rows
      if(data && Array.isArray(data.rows)) return data.rows
      if(data && Array.isArray(data.list)) return data.list
      if(data && data.data && Array.isArray(data.data.list)) return data.data.list
      return []
    },
    extractMallInvoiceTotal(res, fallback) {
      const data = res && res.data
      return Number((res && res.total) || (data && data.total) || (data && data.data && data.data.total)) || fallback
    },
    normalizeMallInvoice(item) {
      const auditStatus = item.auditStatus == null ? '' : String(item.auditStatus)
      const invoiceStatus = item.invoiceStatus == null ? '' : String(item.invoiceStatus)
      return {
        ...item,
        invoiceAmount: Number(item.invoiceAmount || 0).toFixed(2),
        applyCode: item.applyCode || '-',
        applyTypeText: item.applyTypeText || ({ 1: '订单开票', 2: '预存开票' }[item.applyType] || '-'),
        invoiceTypeText: item.invoiceTypeText || this.getMallInvoiceTypeText(item.invoiceType),
        auditStatusText: item.auditStatusText || ({ 1: '待审核', 2: '审核通过', 3: '审核拒绝' }[item.auditStatus] || '-'),
        invoiceStatusText: item.invoiceStatusText === '处理中' ? '待开票' : (item.invoiceStatusText || ({ 1: '待开票', 2: '已开票', 4: '开票失败' }[item.invoiceStatus] || '-')),
        auditStatusClass: auditStatus === '2' ? 'status-success' : (auditStatus === '3' ? 'status-failed' : 'status-wait'),
        invoiceStatusClass: invoiceStatus === '2' ? 'status-success' : (invoiceStatus === '4' ? 'status-failed' : 'status-processing'),
        invoiceFileUrl: item.invoiceFileUrl || '',
        addDate: item.addDate || '-',
      }
    },
    paymentStatusText(status) {
      if(status === 1 || status === '1') return '否'
      if(status === 3 || status === '3') return '是'
      return '-'
    },
    getMallInvoiceTypeText(type) {
      const typeMap = {
        1: '普票',
        2: '专票',
      }
      return typeMap[type] || '-'
    },
    changeMallInvoiceStatus() {
      this.mallQuerySearch.pageNum = 1
      this.getMallInvoiceList()
    },
    clearMallInvoiceStatus() {
      this.mallQuerySearch.invoiceStatus = ''
      this.mallQuerySearch.pageNum = 1
      this.getMallInvoiceList()
    },
    clearQuerySearch() {
      this.status_index = 0
      this.getList();
    },
    changeInvoiceStatus() {
      this.querySearch.pageNum = 1
      this.getList();
    },
    statusFilter(row) {
      if(row.invoiceStatus == 1) return '开票中'
      if(row.invoiceStatus == 3) return '已开票'
      if((row.invoiceStatus == 4 && (row.invoiceResultStatus == 1 || !row.invoiceResultStatus)) || row.invoiceStatus == 6) return '开票失败'
      if(row.invoiceStatus == 4 && row.invoiceResultStatus == 2) return '已销毁'
      return ''
    },
    fileHandle(list, name) {
      if (list.length > 0) {
        const obj = {
          businessName: name,
          businessIds: list.map(item => item.fileId).toString(),
          businessType: 2
        }
        this.$download.getDownLoadXls('/file/communal/download/fileZipDownload', obj)
      }
    },
    downloadFile() {
      this.$download.name('检测报告模板.docx', false)
    },

    downInvoice(row) {
      getInvoiceFile(row.invoiceId).then(res => {
        if (res.data.invoiceFileList.length == 0) {
          this.$message.error("暂无发票数据");
        } else {
          this.fileHandle(res.data.invoiceFileList)
        }
      })
    },
    async downloadMallInvoice(row) {
      const url = process.env.VUE_APP_QINIU_PATH + row.invoiceFileUrl
      window.open(url, '_blank')
    },
    delHandle(row) {
      this.$confirm("确认删除该发票吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false
      })
        .then(function () {
          return invoiceDel(row.invoiceId);
        })
        .then(() => {
          this.getList();
          this.$message.success("操作成功");
        });
    },
    detailInfo(row) {
      this.invoiceDetailVisible = true;
      this.$nextTick(() => {
        this.$refs.invoiceDetail.init(row)
      })
    },
    async mallDetailInfo(row) {
      if(!row || !row.invoiceId) {
        this.$message.error('缺少发票申请ID')
        return
      }
      const rmTeamId = this.getRmTeamId()
      if(!rmTeamId) {
        this.$message.error('未找到商城团队信息')
        return
      }
      try {
        const res = await teamMallInvoiceInfo(rmTeamId, row.invoiceId)
        const detail = (res && res.data) || res || {}
        this.mallInvoiceDetailInfo = this.normalizeMallInvoice(detail)
        this.mallInvoiceDetailVisible = true
      } catch (error) {
        this.$message.error((error && error.message) || '团队耗材发票详情加载失败')
      }
    },
    backMallInvoiceDetail() {
      this.mallInvoiceDetailVisible = false
      this.mallInvoiceDetailInfo = {}
    },
    uploadCertificateHandle(row) {
      this.uploadCertificateVisible = true;
      this.$nextTick(() => {
        this.$refs.uploadCertificate.init(row)
      })
    },
    selPageChange(page) {
      this.querySearch.pageNum = page;
      this.getList();
    },
    handleSizeChange(val) {
      this.querySearch.pageSize = val;
      this.getList();
    },
    selMallPageChange(page) {
      this.mallQuerySearch.pageNum = page;
      this.getMallInvoiceList();
    },
    handleMallSizeChange(val) {
      this.mallQuerySearch.pageSize = val;
      this.mallQuerySearch.pageNum = 1;
      this.getMallInvoiceList();
    },
  }
};
</script>

<style scoped lang="scss">
.filter-box {
  margin-bottom: 10px;
}

.mall-filter-box {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  padding: 14px;
  border: 1px solid #dcdfe6;
  background: #fff;
}

.mall-filter-label {
  margin-right: 8px;
  color: #606266;
  font-size: 14px;
}

.status-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  font-size: 12px;
  line-height: 18px;
}

.status-wait {
  color: #ff3b30;
  background: #fff0f0;
}

.status-processing {
  color: #2f65ff;
  background: #edf2ff;
}

.status-success {
  color: #00a870;
  background: #e9fbf3;
}

.status-failed {
  color: #8c8c8c;
  background: #f5f5f5;
}

.mall-invoice-detail {
  min-height: 700px;
}

.detail-section {
  margin-top: 22px;
}

.goods_info_list {
  line-height: 50px;
  font-size: 14px;
  font-weight: 500;
}

.invoice-log-timeline {
  margin: 10px 20px 0;
}

.detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 26px;
  column-gap: 40px;
  padding: 30px 48px 10px;
  font-size: 14px;
  color: #111;
}

.detail-grid-item {
  min-height: 24px;
  line-height: 24px;
  word-break: break-all;
  span {
    display: inline-block;
    min-width: 100px;
    margin-right: 8px;
    color: #111;
  }
}

.full-line {
  grid-column: 1 / span 2;
}
</style>
